import { camelCase } from "lodash";
import React, { forwardRef, Ref } from "react";
import cn from "classnames";
import { Label } from "./Label";
import { Textfield } from "./Textfield";
import { TextGroupProps } from ".";
import Styles from "./forms.module.scss";

export const TextGroup = forwardRef<HTMLInputElement | null, TextGroupProps>(({
    name,
    size="md",
    label,
    className = "",
    inline = false,
    textProps,
  }: TextGroupProps,
  ref: Ref<HTMLInputElement | null>,
) => {
  const _name = name || camelCase(label);

  return (
    <div className={cn(Styles.textGroup, className, inline ? "justify-between items-center" : "flex-col")}>
      <Label klass="flex-1" name={_name} size={size}><>{label}:</></Label>
      <Textfield ref={ref} klass={inline ? "w-9/12" : undefined} id={_name} name={_name} size={size}  {...textProps} />
    </div>
  );
});

TextGroup.displayName = "TextGroup";

export default TextGroup;
